module.exports = __webpack_public_path__ + "static/media/hot_zydwm.e0cd1e2e.png";